module.exports = __webpack_public_path__ + "static/media/save.a0ddb50b.svg";